module.exports = __webpack_public_path__ + "img/IMG_8618_L_BlackMatted_MockedUp.51ffeebc.jpg";